function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParenthesis = function SvgParenthesis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "9.5 10 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 34A17.1 17.1 0 0 1 11 22a17.1 17.1 0 0 1 4.8-12l1.83 1.083A15.687 15.687 0 0 0 13.01 22a15.643 15.643 0 0 0 4.62 10.9L15.8 34Zm11.4 0-2.066-1.1A16.05 16.05 0 0 0 29.78 22a15.706 15.706 0 0 0-4.645-10.917L27.2 10A17.1 17.1 0 0 1 32 22a17.1 17.1 0 0 1-4.8 12Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgParenthesis;